import { Model } from '../general'

export interface Data {
  id: number
  time?: number
  occupancy: boolean
  charging: boolean
  firmware?: number | null
  pdp_cycle: boolean
  power_cycle: boolean
  led_connected: boolean
  sensor_connected: boolean
  csq: number | null
  rcnt: number
  created_at?: string
  updated_at?: string
}

class Message extends Model<Data> {
  get createdAt() {
    return this.data.created_at ? new Date(this.data.created_at) : undefined
  }
  get updatedAt() {
    return this.data.updated_at ? new Date(this.data.updated_at) : undefined
  }

  get sentAt() {
    return this.data.time ? new Date(this.data.time) : undefined
  }

  get isOccupied() {
    return this.data.occupancy
  }

  get isCharging() {
    return this.data.charging
  }

  get ledConnected() {
    return this.data.led_connected
  }

  get sensorConnected() {
    return this.data.sensor_connected
  }

  get pdpCycle() {
    return this.data.pdp_cycle
  }

  get powerCycle() {
    return this.data.power_cycle
  }

  get csq() {
    return this.data.csq
  }

  get firmware() {
    return this.data.firmware
  }
}

export default Message
